import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_OFFER_CALCULATION_TYPE_MUTATION = gql`
  mutation updateOfferCalculationType($documentVersion: DocumentVersionInput!, $type: String!) {
    quotes {
      modify(documentVersion: $documentVersion) {
        setCustomPropertyValue(key: "CalculationType", stringValue: $type) { id }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateOfferCalculationTypeMutation extends Mutation<RootMutation> {
  document = UPDATE_OFFER_CALCULATION_TYPE_MUTATION;
}
